module.exports = __webpack_public_path__ + "img/iconPrecio.3561342f.svg";